/* global android */
import cookies from '../utils/cookies.js';

let APP = {};

APP.init = function () {
  let zooplusHybridAppObject = (window.zooplus.hybrid =
    window.zooplus.hybrid || {});
  let isMobileApp = cookies.get('MOBILE_APP');

  // Check if it's the native mobile app.
  if (isMobileApp) {
    // class used to adapt the layout for the APP
    if (document.body.classList !== null) {
      document.body.classList.add('hybridApp');
    }
    createGlobalObjects(zooplusHybridAppObject);
    // Push basket count to the app
    if (window.zooplusApp)
      window.zooplusApp.updateUserData(JSON.stringify(getBasketCount()));
  }
};

function getBasketCount() {
  let cartData = $('#cartDataObject').text();
  let count = 0;
  if (cartData && cartData !== '') {
    let jsonData = JSON.parse(cartData);
    let articles = jsonData.cart.articles;
    if (articles.length > 0) {
      jsonData.cart.articles.map((item) => {
        count += item.quantity;
      });
    }
  }
  return {
    basketCount: count,
  };
}

//  Allow the native app communicate with the web application.

function createGlobalObjects(globalObj) {
  globalObj.getUserData = function () {
    let appOS = cookies.get('MOBILE_APP');
    let userData = { result: getBasketCount() };
    if (appOS.toLowerCase().indexOf('ios') !== -1) {
      return JSON.stringify(userData);
    } else if (
      typeof android !== 'undefined' &&
      typeof android.updateUserData === 'function'
    ) {
      android.updateUserData(JSON.stringify(userData));
    }

    // though it is quite ugly that the function returns object for some cases and the stringified object in other cases, we
    // leave it as is, since we're not sure at the moment if the returned value is used
    return userData;
  };
}

export default APP;
